import russianRegions from './data/russianRegions';
const isProd = process.env.NODE_ENV === 'production';
const hostname = isProd ? 'http://s056577c5.fastvps-server.com/' : 'http://localhost:3000/';

export default {
  shippingType:{
    selfPickup: 'selfPickup',
    shipping: 'shipping',
  },
  minLengthForNumberVerifying: 16, //2
  defaultShippingMethod: 'selfPickup',
  cartItemTextMaxLength: 120,
  cartItemSMTextMaxLength: 20,
  routes: {
    main: '/',
    cart: '/cart',
    basket: '/basket',
    checkout: '/checkout',
    payout: '/payout',
    results: '/results',
    search: '/search',
    catalog: '/catalog',
    thanksPage: '/thanks',
    categories: '/categories',
    modifications: '/modifications',
    components: '/components',
    user: '/user',
    garage: '/garage',
    balance: '/balance',
    orders: '/orders',
    biz: '/biz',
    registration: '/registration',
  },
  vkId: isProd ? 5696611 : 5694141,
  fbId: isProd ? 1116539671757668 : 399803210408692,
  vkPermissions: ['email', 'offline', 'nohttps'],
  fbPermissions: ['public_profile', 'email', 'user_friends'],
  vkAuth: 'VK',
  fbAuth: 'FB',
  hostname,
  phoneInputCodeSelectorPreferredCountries: [
    'ru', 'by', 'ua', 'kz'
  ],
  listOfCarBrands: [
    'Acura', 'Audi', 'BMW', 'Cadillac', 'Chevrolet', 'Chrusler', 'Citroen', 'Daewoo', 'Fiat', 'Ford', 'Ford usa', 'Honda', 'Hummer', 'Hunndai', 'Infiity', 'Jaguar', 'Jeep', 'Kia', 'Land Rover', 'Lexus', 'Mazda', 'Mercedes', 'Mitsubishi', 'Nissan', 'Opel', 'Peugeout', 'Pontiac', 'Renaul', 'Rover', 'Saab', 'Saturn', 'Seat', 'Skoda', 'SsangYoung', 'Subaru', 'Suzuki', 'toyouta', 'Volkswagen', 'Volvo', 'Zaz', 'TagAz'
  ],
  timeWhenPasswordResendIsPossible: 300000, //milliseconds
  // timeWhenPasswordResendIsPossible: 3000, //milliseconds
  defaultMapZoom: 9,
  defaultMapCenter: {
    lat: 55.751244,
    lng: 37.618423
  },
  gMapKey: 'AIzaSyBB26qAvLSUcanXTqmv9oGk_zxwEuaIPzw',
  gMapScriptPath: {
    host: 'maps.googleapis.com',
    path: '/maps/api/js'
  },
  geocoderKey: '70eee25c9432abb7687e', //locationiq,
  geocoderZoom: '18', //geocoder preciseness: 0 - lowest, 18 - highest
  countries: {
    russia: {
      regions: russianRegions
    }
  },
  userAlreadyRegisteredServerErrorText: 'На данный номер телефона <br/> уже зарегистрирован аккаунт.'
};



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/